import { InlineStack, Tooltip } from "@shopify/polaris";
import React from "react";

interface Props {
  children: React.ReactNode;
  messageId?: number;
}

export function PricesToolTips({ children, messageId }: Props) {
  if (messageId === 2) {
    return (
      <Tooltip
        content={
          <InlineStack gap="200">
            <span>
              As of 2025, the platform adopted <b>SOP</b> for this report. <br />
              <b>Seller Offer Price (SOP) </b> is your price you intend to get when your product is sold (minus
              inventory storage, inventory processing/removal, and pickup fees).
              <br />
              <b>App Offer Price (AOP) </b>is the price the buyer sees. AOP includes necessary service fees the platform
              and partner operators charge the buyer to sustain the platform and partner operators.
            </span>
          </InlineStack>
        }
        width="wide"
      >
        {children}
      </Tooltip>
    );
  } else if (messageId === 3) {
    return (
      <Tooltip
        content={
          <InlineStack gap="200">
            <span>
              <b>DF</b>: Delivery fees include (a) the fee for picking up your product at your site and (2) the delivery
              fee you pay for the buyer.
              <br />
              <b>HF</b>: Handling fee is for picking and packing the item.
              <br />
              <b>CM</b>: Commissions are for (a) the platform technology and coordination and (b) partner operation
              services such as sales/aftersales support
            </span>
          </InlineStack>
        }
        width="wide"
      >
        {children}
      </Tooltip>
    );
  }

  return (
    <Tooltip
      content={
        <InlineStack gap="200">
          <b>Seller Offer Price (SOP) </b>is your price you intend to get when your product is sold (minus inventory
          storage, inventory processing/removal, and pickup fees).
          <b>App Offer Price (AOP) </b>is the price the buyer sees. AOP includes necessary service fees the platform and
          partner operators charge the buyer to sustain the platform and partner operators.
        </InlineStack>
      }
      width="wide"
    >
      {children}
    </Tooltip>
  );
}
